















import { Component, Prop, Vue } from 'vue-property-decorator';
import { getItemFromSessionStorageAsBoolean, setItemInSessionStorage } from '@utils/web-storage';
import { app } from '@src/store/modules/app';

@Component
export default class BasicBanner extends Vue {
	@Prop()
	dismissalKey!: string;

	get showBanner(): boolean {
		return !getItemFromSessionStorageAsBoolean(this.dismissalKey);
	}

	get isDesktop(): boolean {
		return app.screenSize === 'DESKTOP';
	}

	closeBanner(): void {
		setItemInSessionStorage(this.dismissalKey, 'true');
		app.UPDATE_CURRENT_BANNER(null);

		// Offset the page "jump" when the added page top padding is removed
		if (this.isDesktop) {
			window.scrollBy(0, -56);
		} else {
			window.scrollBy(0, -80);
		}
	}
}
